export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9528.60c38b74.jpg";